'use strict';
const angular = require('angular');

/*@ngInject*/
export function PiperListService($resource) {

  return $resource('/api/piper/lists/:id', {
    id: '@_id'
  },{
    update: {
      method: 'PUT'
    },
    getByHostAndType: {
      method: 'GET',
      url: "/api/piper/lists/host/:hostid/type/:type",
      isArray: true
    },
    getTodayByHost: {
      method: 'GET',
      url: "/api/piper/lists/host/:hostid/today",
      isArray: true
    }
  });

}

export default angular.module('conduuApp.PiperListService', [])
  .factory('PiperListService', PiperListService)
  .name;



// WEBPACK FOOTER //
// ./client/services/piper-list/piper-list.service.js